module.exports = "<div class=\"container\">\n    <div class=\"row\">\n        <div class=\"col-md-8 col-md-offset-2 centered-pills\" style=\"margin-top: 20px;\" >\n            <nav role=\"navigation\"></nav>\n        </div>\n    </div>\n    <div id=\"settings-main-subview\"></div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./srv/public/js/templates/settings/settings.html
// module id = 1030
// module chunks = 7